import moment, { Moment } from 'moment';
import { ChangeEvent, Fragment, PureComponent, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import Fuse from 'fuse.js';
import LeftBar from '../components/common/NavBar';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import fetchAllHEOrder, { Order, OrderDetails } from '../api/fetchAllHEOrder';
import {
    GO_TO_HE_DASHBOARD,
    GO_TO_HE_ONBOARDING,
    GO_TO_NEW_HXNG_FLOW,
    GO_TO_PATIENTS_DETAILS,
    PaymentsDashboardQueryParams,
} from '../routes/paths';
import HEDashboardStatusFilters from '../components/HEDashboard/HEDashboardStatusFilter';
import { Alert, Dropdown, Menu, notification, Radio, Table } from 'antd';
import { ColumnGroupType, ColumnType } from 'antd/lib/table';
import { getAgeInYears, getAgeString } from '../store/utils';
import { Profile } from '../api/switchDoctor';
import { AppointmentDetails } from '../api/fetchInvoice';
import { track } from '../tracking';
import { AnimatePresence } from 'framer-motion';
import { AppointmentWithPatient } from '../api/fetchAppointmentsV2';
import { OrderMedicineDialog } from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicine';
import { amIDoctorOnly, getDocIds, getSingleDoctor } from '../store/idbHandler';
import {
    addAlpha,
    getColorForString,
    getPxPrintUrl,
    isDoctor,
    isOnboardedForLab,
    isOnboardedForPharma,
    isRXMonetisationT1,
    isRXMonetisationT2,
    isRXMonetisationT3,
    isRXMonetisationT4,
    openCrispChat,
} from './utils';
import { getPatientNameText } from './AppointmentUtils';
import EmptyView from '../components/HEDashboard/EmptyView';
import {
    GetMedicineOrderStatus,
    OrderPlacedFromObj,
    paymodeObj,
} from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicineUtils';
import {
    ADDRESS_FORM_INPUT,
    BookLabTestsDialog,
} from '../components/prescriptionPad/rightPanel/finishScreen/BookLabTests';
import { connect } from 'react-redux';
import FetchError from '../components/HEDashboard/FetchError';
import {
    AddressFormInput,
    GetLabOrderStatus,
    SelectedSlotDetails,
    getTimeIn12HourFormat,
} from '../components/prescriptionPad/rightPanel/finishScreen/BookLabTestsUtils';
import { Data as MedicineData } from '../api/getMedicinesOrder';
import { Data as LabData } from '../api/getLabTestsOrder';
import { AntTooltip } from '../components/common/AntTooltip';
import getHEOnboardingProfile from '../api/getHEOnboardingProfile';
import { captureError, captureErrorString } from './captureError';
import { settingsIcon2 } from '../components/common/Icons';
import { GetCurrentOrderStatus, GetPayoutsModal, MoreOptionsDropdown } from './HEDashboardUtils';
import CancelOrderOrBooking from './CancelOrderOrBooking';
import { OptionItem } from './profile/OptionItem';
import getPayouts, { Payout } from '../api/getPayouts';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import DateFilter from '../components/headerfilters/DateFilter';
import { RangeValue } from '../components/common/DatePicker';
import { BankAccounts } from '../components/BankAccounts';
import capitalize from 'lodash/capitalize';
import getActiveOrders from '../api/getActiveOrders';
import SelectSlotModal from '../components/prescriptionPad/rightPanel/finishScreen/SelectSlotModal';

const fuseConfig = {
    keys: ['_name', '_phone'],
    threshold: 0.2,
    ignoreLocation: true,
    useExtendedSearch: true,
};

export type FetchState = 'loading' | 'success' | 'error' | '';
export type OrderStatusFilterType = 'not-ordered' | 'pending' | 'delivered';
export type TimeFilterType =
    | 'today'
    | 'yesterday'
    | 'last-7-days'
    | 'current-month'
    | 'last-3-months';

export type AppointmentWithOrder = AppointmentWithPatient & Order;

export type ActiveTab = 'meds' | 'labs' | 'all-orders';

export enum ACTIVE_TAB {
    MEDS = 'meds',
    LABS = 'labs',
    ALL_ORDERS = 'all-orders',
}

type State = {
    fetchState: FetchState;
    filteredTransactions: Order[];
    apptDialogVisible?: AppointmentWithOrder;
    searchFilter: string;
    lastUpdated: string;
    switchColumn: FetchState;
    activeTab: ActiveTab;
    tableKey: number;
    missingDetailsInOnboarding?: string[];
    activeOrder?: OrderDetails;
    payouts?: Payout[];
    latestPayoutAmount?: number;
    isPayoutsModalVisible?: boolean;
    isBankAccountsModalVisible?: boolean;
    currTimeFilter?: string;
    dates?: RangeValue<Moment> | undefined;
    showFeelGoodData?: boolean;
    statusFiltersSet: Set<string>;
    editOrder?: Order;
    isForEditOrder?: boolean;
};

type RouterProps = {
    orderStatusFilter: OrderStatusFilterType;
};

type Props = RouteComponentProps<RouterProps>;

export const timeFiltersObj: {
    [k in TimeFilterType]: {
        id: TimeFilterType;
        label: string;
        startDate: string;
        endDate: string;
    };
} = {
    today: {
        id: 'today',
        label: 'Today',
        startDate: moment().startOf('day').toISOString(),
        endDate: moment().endOf('day').toISOString(),
    },
    yesterday: {
        id: 'yesterday',
        label: 'Yesterday',
        startDate: moment().subtract(1, 'days').startOf('day').toISOString(),
        endDate: moment().subtract(1, 'days').endOf('day').toISOString(),
    },
    'last-7-days': {
        id: 'last-7-days',
        label: 'Last 7 Days',
        startDate: moment().subtract(6, 'days').startOf('day').toISOString(),
        endDate: moment().endOf('day').toISOString(),
    },
    'current-month': {
        id: 'current-month',
        label: 'Current Month',
        startDate: moment().startOf('month').toISOString(),
        endDate: moment().add(1, 'days').startOf('day').toISOString(),
    },
    'last-3-months': {
        id: 'last-3-months',
        label: 'Last 3 Months',
        startDate: moment().subtract(3, 'months').startOf('day').toISOString(),
        endDate: moment().add(1, 'days').startOf('day').toISOString(),
    },
};

type TransactionsWithMeta = {
    transactions: Order[];
    amount?: number;
};

export const orderFiltersObj: {
    [k in OrderStatusFilterType]: {
        id: OrderStatusFilterType;
        label: { [k: string]: string };
        getData: (array: Order[]) => TransactionsWithMeta;
    };
} = {
    'not-ordered': {
        id: 'not-ordered',
        label: { meds: 'Not Ordered', labs: 'Not Ordered' },
        getData: (array: Order[]) => ({
            transactions: array.filter((i) => i.status === 'not ordered'),
        }),
    },
    pending: {
        id: 'pending',
        label: { meds: 'Pending', labs: 'Ordered' },
        getData: (array: Order[]): TransactionsWithMeta => ({
            transactions: array.filter((i) => i.status === 'init' || i.status === 'cancelled'),
        }),
    },
    delivered: {
        id: 'delivered',
        label: { meds: 'Delivered', labs: 'Completed' },
        getData: (array: Order[]): TransactionsWithMeta => ({
            transactions: array.filter((i) => i.status === 'delivered'),
        }),
    },
};
export type FilterData = { [k in OrderStatusFilterType]: { count: number; amount?: number } };

const CANCELLED = 'cancelled';

class HEDashboard extends PureComponent<Props, State> {
    counts: FilterData | undefined = undefined;
    allTransactions: Order[] = [];
    transactionsFuse = new Fuse([] as Order[], fuseConfig);

    initialState: State = {
        fetchState: '',
        filteredTransactions: [],
        searchFilter: '',
        lastUpdated: new Date().toISOString(),
        switchColumn: 'success',
        activeTab: ACTIVE_TAB.ALL_ORDERS,
        tableKey: 0,
        activeOrder: undefined,
        showFeelGoodData: false,
        statusFiltersSet: new Set(),
    };

    state: State = {
        ...this.initialState,
        dates: undefined,
        currTimeFilter: timeFiltersObj['last-7-days'].label,
        payouts: [],
        latestPayoutAmount: 0,
    };

    componentDidMount = (): void => {
        const { history } = this.props;
        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();
        const { orderStatusFilter } = this.props.match.params;
        const { getHEOnboardingProfileMissingDetails, getPayoutsDetails } = this;
        const showDashboard = new URLSearchParams(this.props.location.search).get('showDashboard');
        if (
            !isOnboardedForPharma() &&
            !isOnboardedForLab() &&
            !isRXMonetisationT3() &&
            !isRXMonetisationT4() &&
            showDashboard !== 'true'
        ) {
            history.replace(GO_TO_NEW_HXNG_FLOW);
            return;
        }

        const newState = {
            fetchState: 'loading',
        };
        const callBack = () => {
            if (startDate && endDate) {
                this.fetchTransactions(
                    startDate,
                    endDate,
                    orderStatusFilter,
                    ACTIVE_TAB.ALL_ORDERS,
                );
            } else {
                this.getAllTransactions();
            }
        };
        this.setState(newState as State, callBack);
        getHEOnboardingProfileMissingDetails();
        amIDoctorOnly() && getPayoutsDetails();
    };

    componentWillUnmount = (): void => {
        const shepherdTourDivs = document.getElementsByClassName(
            'shepherd-tour',
        ) as HTMLCollectionOf<HTMLElement>;
        Array.from(shepherdTourDivs).forEach((ele) => ele && ele.remove());
    };

    getHEOnboardingProfileMissingDetails = async (): Promise<void> => {
        try {
            const { success, profile, error = '' } = await getHEOnboardingProfile();
            if (success && profile) {
                const { bank_details = {}, pancard = '' } = profile;
                const { fund_acc_id = '' } = bank_details;
                const missingDetailsInOnboarding = [];

                if (!fund_acc_id.trim()) missingDetailsInOnboarding.push('bank');
                if (pancard.trim().length !== 10) missingDetailsInOnboarding.push('pancard');

                this.setState({
                    missingDetailsInOnboarding,
                });
            } else {
                captureErrorString(error);
                track('ERROR', { on: 'getHEOnboardingProfile', what: error });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getHEOnboardingProfile',
                error: (error as Error).message,
            });
        }
    };

    componentDidUpdate = (prevProps: Props): void => {
        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();

        const previousStartDate =
            new URLSearchParams(prevProps.location.search).get(
                PaymentsDashboardQueryParams.start_date,
            ) || '';
        const previousEndDate =
            new URLSearchParams(prevProps.location.search).get(
                PaymentsDashboardQueryParams.end_date,
            ) || '';

        if (previousStartDate !== startDate || previousEndDate !== endDate) {
            this.getAllTransactions();
        }
    };

    goToDefaultUrl = (): void => {
        const { startDate, endDate } = timeFiltersObj['last-7-days'];
        const { orderStatusFilter } = this.props.match.params;
        const showDashboard = new URLSearchParams(this.props.location.search).get('showDashboard');
        return this.props.history.replace(
            GO_TO_HE_DASHBOARD(
                orderStatusFilter || 'not-ordered',
                startDate,
                endDate,
                showDashboard === 'true',
            ),
        );
    };

    getStartDateAndEndDateFromUrl = (): { startDate: string; endDate: string } => {
        const startDate =
            new URLSearchParams(this.props.location.search).get(
                PaymentsDashboardQueryParams.start_date,
            ) || '';

        const endDate =
            new URLSearchParams(this.props.location.search).get(
                PaymentsDashboardQueryParams.end_date,
            ) || '';

        return { startDate, endDate };
    };

    getAllTransactions = (): void => {
        const { activeTab } = this.state;
        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();
        const { orderStatusFilter } = this.props.match.params;

        if (
            !moment(startDate).isValid() ||
            !moment(endDate).isValid() ||
            !Object.keys(orderFiltersObj).includes(orderStatusFilter)
        ) {
            this.goToDefaultUrl();
            return;
        }

        this.setState({
            ...this.initialState,
            activeTab,
            fetchState: 'loading',
            lastUpdated: new Date().toISOString(),
        });

        this.fetchTransactions(startDate, endDate, orderStatusFilter, activeTab);
    };

    fetchTransactions = (
        startDate: string,
        endDate: string,
        orderStatusFilter: OrderStatusFilterType,
        activeTab: ActiveTab,
    ): void => {
        const { getData: getTransactions } = orderFiltersObj[orderStatusFilter];
        const docIds = getDocIds().join(',');

        if (activeTab === ACTIVE_TAB.ALL_ORDERS) {
            const from = moment(startDate).format('YYYY-MM-DD');
            const to = moment(endDate).format('YYYY-MM-DD');
            getActiveOrders(docIds, undefined, from, to)
                .then((res) => {
                    if (res.success) {
                        this.counts = undefined;
                        this.allTransactions = res.orders;
                        this.setState({
                            fetchState: 'success',
                            filteredTransactions: res.orders,
                            lastUpdated: new Date().toISOString(),
                            statusFiltersSet: new Set(),
                        });
                        this.setupTransactionsFuse(res.orders);
                    } else {
                        this.counts = undefined;
                        this.setState({
                            fetchState: 'error',
                        });
                    }
                })
                .catch((e: Error) => {
                    this.counts = undefined;
                    this.setState({
                        fetchState: 'error',
                    });
                    track('ERROR', { on: 'getActiveOrders', what: (e as Error).message });
                    captureError(e);
                });
        } else {
            fetchAllHEOrder(docIds, startDate, endDate, activeTab)
                .then((res) => {
                    if (res.success) {
                        const filterData: FilterData = {} as FilterData;
                        (Object.keys(orderFiltersObj) as OrderStatusFilterType[]).forEach((k) => {
                            const t = orderFiltersObj[k].getData(res.allOrders);
                            const amount = t.transactions.reduce((acc, cur) => {
                                const { paidAmount = 0 } = cur;
                                return acc + paidAmount || 0;
                            }, 0);
                            filterData[k] = {
                                count: t.transactions.length,
                                amount: amount || undefined,
                            };
                        });
                        this.counts = filterData;
                        this.allTransactions = res.allOrders;
                        this.setState({
                            fetchState: 'success',
                            filteredTransactions: getTransactions(res.allOrders).transactions,
                            lastUpdated: new Date().toISOString(),
                        });
                        this.setupTransactionsFuse(getTransactions(res.allOrders).transactions);
                        setTimeout(() => {
                            const startTourButton = document.getElementById('start-tour');
                            startTourButton && startTourButton.click();
                        }, 1000);
                    } else {
                        this.counts = undefined;
                        this.setState({
                            fetchState: 'error',
                        });
                    }
                })
                .catch((e) => {
                    this.counts = undefined;
                    this.setState({
                        fetchState: 'error',
                    });
                    track('ERROR', { on: 'fetchAllHEOrder', what: (e as Error).message });
                    captureError(e);
                });
        }
    };

    setupTransactionsFuse = (transactions: Order[]): void => {
        const { activeTab } = this.state;
        this.transactionsFuse = new Fuse(
            transactions.map((t) => ({
                ...t,
                _name:
                    activeTab === ACTIVE_TAB.ALL_ORDERS
                        ? t.patient_name
                        : t.patient
                        ? getPatientNameText(t.patient)
                        : '',
                _phone:
                    activeTab === ACTIVE_TAB.ALL_ORDERS
                        ? `+91${t.customer_details?.mobile}`
                        : t.patient
                        ? `+91${t.patient.mobile}`
                        : '',
            })),
            fuseConfig,
        );
    };

    setTimeFilter = (startDate: string, endDate: string): void => {
        const { activeTab } = this.state;
        const {
            startDate: currentStartDate,
            endDate: currentEndDate,
        } = this.getStartDateAndEndDateFromUrl();
        if (moment(startDate).isSame(currentStartDate) && moment(endDate).isSame(currentEndDate)) {
            return;
        }

        const { orderStatusFilter } = this.props.match.params;
        const showDashboard = new URLSearchParams(this.props.location.search).get('showDashboard');
        this.props.history.replace(
            GO_TO_HE_DASHBOARD(orderStatusFilter, startDate, endDate, showDashboard === 'true'),
        );
        this.fetchTransactions(startDate, endDate, orderStatusFilter, activeTab);
        track('HE_DASHBOARD_DATE_FILTER', {
            startDate: moment(startDate).format('lll'),
            endDate: moment(endDate).format('lll'),
            orderStatusFilter,
            activeTab,
        });
    };

    setOrderFilter = (orderFilter: OrderStatusFilterType, closeTour?: boolean): void => {
        const { orderStatusFilter } = this.props.match.params;
        const { getData: getTransactions } = orderFiltersObj[orderFilter];
        if (orderStatusFilter === orderFilter && !closeTour) {
            return;
        }
        const { allTransactions } = this;

        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();

        const transactions = getTransactions(allTransactions).transactions;

        const showDashboard = new URLSearchParams(this.props.location.search).get('showDashboard');
        this.props.history.replace(
            GO_TO_HE_DASHBOARD(orderFilter, startDate, endDate, showDashboard === 'true'),
        );
        this.setupTransactionsFuse(transactions);
        this.setState({
            filteredTransactions: transactions,
            switchColumn: transactions.length ? 'loading' : 'success',
            tableKey: this.state.tableKey + 1,
        });

        setTimeout(() => {
            this.setState({
                switchColumn: 'success',
            });
        }, 150);
    };

    onSearchInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            searchFilter: e.target.value,
        });
    };

    clearSearchFilter = (): void => {
        this.setState({
            searchFilter: '',
        });
    };

    onPatientsDetails = (id: string): void => {
        const { history } = this.props;
        history.push(GO_TO_PATIENTS_DETAILS(id, 'visit'));
    };

    buildColumns = (columnArray: string[]): (ColumnGroupType<Order> | ColumnType<Order>)[] => {
        const { match } = this.props;
        const { orderStatusFilter } = match.params;
        const { activeTab } = this.state;
        const isMedsTabActive = activeTab === ACTIVE_TAB.MEDS;
        const isLabsTabActive = activeTab === ACTIVE_TAB.LABS;
        const isAllOrdersTabActive = activeTab === ACTIVE_TAB.ALL_ORDERS;
        const isNotOrdered = orderStatusFilter === 'not-ordered';
        const isPending = orderStatusFilter === 'pending';
        const isForLabsColumn = !isNotOrdered && isLabsTabActive;
        const isForLabsDeliveredColumn = isLabsTabActive && orderStatusFilter === 'delivered';

        const columns: { [k: string]: ColumnGroupType<Order> | ColumnType<Order> } = {
            SEQ: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">SEQ</span>,
                width: 60,
                key: 'index',
                render: (_: Order, __: Order, index: number): ReactNode => {
                    return (
                        <p className="text-14 text-darwin-neutral-900 whitespace-nowrap">
                            {index + 1}
                        </p>
                    );
                },
                fixed: 'left',
            },
            PATIENT_DETAILS: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">
                        PATIENT DETAILS
                    </span>
                ),
                width: isForLabsColumn ? 210 : 280,
                dataIndex: 'patient',
                key: 'patient',
                render: (patient: Profile, order: Order): ReactNode => {
                    const { patient_name, order_details } = order;
                    const patientNameArray = patient_name?.split(' ');
                    const color = getColorForString(patient_name || getPatientNameText(patient));
                    return (
                        <button
                            className="flex items-start space-x-8 text-14 text-darwin-neutral-900"
                            onClick={() =>
                                this.onPatientsDetails(
                                    order_details?.patientid || patient.oid || '',
                                )
                            }
                        >
                            <span
                                style={{ color: color, backgroundColor: addAlpha(color, 0.1) }}
                                className="rounded-full w-24 h-24 min-w-24 min-h-24 text-12 font-700 flex items-center justify-center"
                            >
                                {patientNameArray && patientNameArray.length > 0 ? (
                                    <span>
                                        {patientNameArray[0] && patientNameArray[0][0]}
                                        {patientNameArray[patientNameArray.length - 1] &&
                                            patientNameArray[patientNameArray.length - 1][0]}
                                    </span>
                                ) : (
                                    <span>
                                        {patient.fn && patient.fn[0]}
                                        {patient.ln && patient.ln[0]}
                                    </span>
                                )}
                            </span>
                            <span className="relative top-2 text-left">
                                <span className="text-actionPrimary break-words">
                                    {patient_name || patient.fln},{' '}
                                </span>
                                <span className="break-words">
                                    {patient.gen},{' '}
                                    {getAgeString({
                                        dob: patient.dob,
                                    })}
                                </span>
                            </span>
                        </button>
                    );
                },
                fixed: 'left',
            },
            PATIENT_DETAILS_NEW: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">
                        PATIENT DETAILS
                    </span>
                ),
                width: 225,
                key: 'patient',
                render: (_, order: Order): ReactNode => {
                    const { patient_name = "Not available'", patient_id, customer_details } = order;
                    const patientNameArray = patient_name?.split(' ');
                    const color = getColorForString(patient_name);
                    const [fn, ln] = Array.isArray(patientNameArray) ? patientNameArray : [];
                    const gen = customer_details?.gender?.[0]?.toUpperCase();
                    const age = customer_details?.age;
                    const mobile = customer_details?.mobile;
                    return (
                        <button
                            className="text-14 text-darwin-neutral-900"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.onPatientsDetails(patient_id || '');
                            }}
                        >
                            <div className="flex items-start space-x-8">
                                <span
                                    style={{ color: color, backgroundColor: addAlpha(color, 0.1) }}
                                    className="rounded-full w-24 h-24 min-w-24 min-h-24 text-10 font-700 flex items-center justify-center"
                                >
                                    {patientNameArray && patientNameArray.length > 0 ? (
                                        <span>
                                            {patientNameArray[0] && patientNameArray[0][0]}
                                            {patientNameArray[patientNameArray.length - 1] &&
                                                patientNameArray[patientNameArray.length - 1][0]}
                                        </span>
                                    ) : (
                                        <span>
                                            {fn && fn[0]}
                                            {ln && ln[0]}
                                        </span>
                                    )}
                                </span>
                                <span className="relative top-2 text-left text-13">
                                    <span className="text-darwin-accent-bright-blue-800 break-words">
                                        {patient_name}
                                    </span>
                                    <span className="break-words">
                                        {gen ? `, ${gen}` : ''}
                                        {age ? `, ${age}y` : ''}
                                    </span>
                                </span>
                            </div>
                            {mobile && (
                                <p className="w-max text-11 pt-4 pl-32 text-darwin-neutrals-600">
                                    +91 {mobile}
                                </p>
                            )}
                        </button>
                    );
                },
                fixed: 'left',
                sorter: (a, b) => (a.patient_name || '').localeCompare(b.patient_name || ''),
            },
            CONTACT: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">CONTACT</span>,
                width: isForLabsColumn ? 140 : 160,
                dataIndex: 'patient',
                key: 'patient',
                render: (patient: Profile): ReactNode => {
                    return <p className="text-14 text-darwin-neutral-900">{patient.mobile}</p>;
                },
            },
            VISITED_ON: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">VISITED ON</span>,
                dataIndex: 'appointment_details',
                key: 'appointment_details',
                render: (appointment_details: AppointmentDetails): ReactNode => {
                    return (
                        <p className="text-14 text-darwin-neutral-900">
                            {moment(appointment_details.end_time).format('lll')}
                        </p>
                    );
                },
            },
            ORDER_STATUS: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">ORDER STATUS</span>
                ),
                width: isLabsTabActive ? 170 : 135,
                dataIndex: 'order_details',
                key: 'order_details',
                render: (order_details: OrderDetails): ReactNode => {
                    return isMedsTabActive ? (
                        <GetMedicineOrderStatus order_details={order_details as MedicineData} />
                    ) : (
                        <GetLabOrderStatus order_details={order_details as LabData} />
                    );
                },
                filters: [
                    {
                        text: 'Order Placed',
                        value: 'init',
                    },
                    {
                        text: 'Cancelled',
                        value: 'cancelled',
                    },
                    {
                        text: 'Pickup',
                        value: 'phleboassigned',
                    },
                    {
                        text: 'Sample Collected',
                        value: 'pickup',
                    },
                    {
                        text: 'Rescheduled',
                        value: 'rescheduled',
                    },
                ],
                onFilter: (value: string | number | boolean, record: Order): boolean =>
                    record.order_details?.sub_status?.indexOf(value as string) === 0,
            },
            ORDER_STATUS_NEW: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">CURRENT STATUS</span>
                ),
                width: 225,
                key: 'order_details',
                render: (_, order: Order): ReactNode => {
                    return (
                        <div className="whitespace-nowrap flex items-center justify-between">
                            {order.type === ACTIVE_TAB.MEDS ? (
                                <GetMedicineOrderStatus
                                    order_details={(order as unknown) as MedicineData}
                                    showTag
                                />
                            ) : order.type === ACTIVE_TAB.LABS ? (
                                <GetLabOrderStatus
                                    order_details={(order as unknown) as LabData}
                                    showTag
                                />
                            ) : null}
                            <GetCurrentOrderStatus order_details={order} />
                        </div>
                    );
                },
            },
            REMARKS: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">REMARKS</span>,
                width: 170,
                key: 'remarks',
                render: (_: Order, order: Order): ReactNode => {
                    return (
                        <div className="text-13 text-darwin-neutral-900">
                            {order.external_remarks?.map((i) => <p>{i}</p>) || '-'}
                        </div>
                    );
                },
                sorter: (a, b) =>
                    (a.external_remarks?.join(' ') || '').localeCompare(
                        b.external_remarks?.join(' ') || '',
                    ),
                filters: [
                    {
                        text: 'Remark Missing',
                        value: 'missing',
                    },
                    {
                        text: 'Remark Filled',
                        value: 'filled',
                    },
                ],
                onFilter: (value: string | number | boolean, order: Order) => {
                    const isRemarkMissing = !order.external_remarks?.join(' ');
                    return value === 'missing'
                        ? isRemarkMissing
                        : value === 'filled'
                        ? !isRemarkMissing
                        : false;
                },
            },
            PAYMODE: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700 whitespace-nowrap">
                        PAYMENT MODE
                    </span>
                ),
                width: isLabsTabActive ? (isPending ? 140 : 150) : isPending ? 165 : 199,
                render: (order: Order): ReactNode => {
                    const { order_details } = order;
                    return (
                        <p className="whitespace-nowrap">
                            {paymodeObj[order_details?.paymode || '-']}
                        </p>
                    );
                },
                filters: [
                    {
                        text: 'Collected in Clinic',
                        value: 'IC',
                    },
                    {
                        text: 'Pay on Delivery',
                        value: 'COD',
                    },
                    {
                        text: 'Paid to EKA',
                        value: 'EKA',
                    },
                ],
                onFilter: (value: string | number | boolean, record: Order): boolean =>
                    record.order_details?.paymode?.indexOf(value as string) === 0,
            },
            SLOT_DETAILS: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">SLOT DETAILS</span>
                ),
                width: isPending ? 150 : 165,
                render: (order: Order): ReactNode => {
                    const { order_details } = order;
                    if (!order_details) return null;
                    const {
                        collection_date,
                        collection_slot,
                        inclinic_sample_collection,
                    } = order_details as LabData;
                    const { start_time, end_time } = collection_slot.details;
                    return (
                        <div className="space-y-5 text-13 whitespace-nowrap">
                            <p>{moment(collection_date).format('DD MMMM YYYY')}</p>
                            {inclinic_sample_collection ? (
                                <p className="text-darwin-neutral-800">In-clinic Collection</p>
                            ) : (
                                <p className="text-darwin-neutral-800">
                                    {getTimeIn12HourFormat(start_time)} -{' '}
                                    {getTimeIn12HourFormat(end_time)}
                                </p>
                            )}
                        </div>
                    );
                },
            },
            AMOUNT: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">AMOUNT</span>,
                width: isAllOrdersTabActive ? 130 : isForLabsColumn ? 135 : 165,
                render: (order: Order): ReactNode => {
                    const { paidAmount, amount, platformdiscount } = order;
                    const discount = Math.round(platformdiscount || 0);
                    return (
                        <div className="space-y-4">
                            {paidAmount ? (
                                <Fragment>
                                    <p className="text-14 text-darwin-neutral-900">
                                        ₹ {paidAmount?.toFixed(2)}
                                    </p>
                                    {discount > 0 && (
                                        <p className="space-x-6 text-12 text-darwin-neutral-700">
                                            <span className="line-through">
                                                ₹ {Math.ceil(amount as number)}
                                            </span>
                                            <span className="text-darwin-accent-green-900">
                                                {discount > 0 && `${discount}% OFF`}
                                            </span>
                                        </p>
                                    )}
                                </Fragment>
                            ) : (
                                <p className="font-700 text-13 text-darwin-neutral-700">
                                    Price Unavailable
                                </p>
                            )}
                        </div>
                    );
                },
                sorter: ({ paidAmount: a = 0 }, { paidAmount: b = 0 }) => a - b,
            },
            ORDER_PLACED: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">ORDER PLACED</span>
                ),
                dataIndex: 'created_at',
                key: 'created_at',
                width: isForLabsColumn ? 165 : 200,
                render: (created_at: string, order: Order): ReactNode => {
                    const { service_id = '' } = order;
                    const { text, icon } = OrderPlacedFromObj[service_id] || {};
                    return (
                        <p
                            className={`flex items-center whitespace-nowrap ${
                                isForLabsColumn ? 'text-13 space-x-4' : 'text-14 space-x-8'
                            } text-darwin-neutral-900`}
                        >
                            <span>{moment(created_at).format('lll')}</span>
                            <AntTooltip placement="bottom" content={text}>
                                <span>{icon}</span>
                            </AntTooltip>
                        </p>
                    );
                },
                sorter: ({ created_at: a = '' }, { created_at: b = '' }): number =>
                    new Date(a) < new Date(b) ? -1 : 1,
                filters: [
                    {
                        text: 'Placed through Whatsapp',
                        value: 'whatsapp',
                    },
                    {
                        text: 'Placed through Eka.care App',
                        value: 'patient-app',
                    },
                    {
                        text: 'Placed through EMR',
                        value: 'doc-tool',
                    },
                ],
                onFilter: (value: string | number | boolean, record: Order): boolean =>
                    record?.service_id?.indexOf(value as string) === 0,
            },
            ORDER_PLACED_NEW: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">ORDER</span>,
                dataIndex: 'created_at',
                key: 'created_at',
                width: 135,
                render: (created_at: string, order: Order): ReactNode => {
                    const { service_id = '', type } = order;
                    const { text, icon } = OrderPlacedFromObj[service_id] || {};
                    return (
                        <div className="space-y-5 text-13">
                            {type === ACTIVE_TAB.MEDS ? (
                                <div className="flex items-center space-x-5">
                                    <p>
                                        <svg
                                            className="w-16 h-16 fill-darwin-neutrals-600"
                                            viewBox="0 0 16 16"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M3.53125 4.0625C2.8457 4.0625 2.3125 4.62109 2.3125 5.28125V8.125H4.75V5.28125C4.75 4.62109 4.19141 4.0625 3.53125 4.0625ZM0.6875 5.28125C0.6875 3.73242 1.95703 2.4375 3.53125 2.4375C5.08008 2.4375 6.375 3.73242 6.375 5.28125V10.9688C6.375 12.543 5.08008 13.8125 3.53125 13.8125C1.95703 13.8125 0.6875 12.543 0.6875 10.9688V5.28125ZM14.7539 11.7812C14.5762 12.0859 14.1699 12.1113 13.916 11.8574L9.14258 7.08398C8.88867 6.83008 8.91406 6.42383 9.21875 6.24609C9.82812 5.89062 10.5137 5.6875 11.25 5.6875C13.4844 5.6875 15.3125 7.51562 15.3125 9.75C15.3125 10.4863 15.1094 11.1719 14.7539 11.7812ZM13.2559 13.2793C12.6719 13.6348 11.9609 13.8125 11.25 13.8125C8.99023 13.8125 7.1875 12.0098 7.1875 9.75C7.1875 9.03906 7.36523 8.32812 7.7207 7.74414C7.89844 7.43945 8.30469 7.41406 8.55859 7.66797L13.332 12.4414C13.5859 12.6953 13.5605 13.1016 13.2559 13.2793Z" />
                                        </svg>
                                    </p>
                                    <p>Pharmacy</p>
                                </div>
                            ) : type === ACTIVE_TAB.LABS ? (
                                <div className="flex items-center space-x-5">
                                    <p>
                                        <svg
                                            className="w-14 h-14 fill-darwin-neutrals-600"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M9.18359 0.878906L9.99609 1.69141L12.4336 4.12891L13.2461 4.94141C13.5762 5.24609 13.5762 5.7793 13.2461 6.08398C12.9414 6.41406 12.4082 6.41406 12.1035 6.08398L11.875 5.85547L4.79102 12.9141C4.33398 13.3711 3.72461 13.625 3.06445 13.625H2.9375C1.5918 13.625 0.5 12.5332 0.5 11.1875V11.0605C0.5 10.4004 0.753906 9.79102 1.21094 9.33398L8.26953 2.27539L8.04102 2.02148C7.71094 1.7168 7.71094 1.18359 8.04102 0.878906C8.3457 0.548828 8.87891 0.548828 9.18359 0.878906ZM5.70508 7.125H8.26953L10.707 4.6875L9.4375 3.41797L5.70508 7.125Z" />
                                        </svg>
                                    </p>
                                    <p>Lab</p>
                                </div>
                            ) : null}
                            <p className="flex items-center whitespace-nowrap text-11 space-x-8 text-darwin-neutrals-600">
                                <span>{moment(created_at).format("DD MMM'YY, hh:mm A")}</span>
                                <AntTooltip placement="bottom" content={text}>
                                    <span>{icon}</span>
                                </AntTooltip>
                            </p>
                        </div>
                    );
                },
                sorter: ({ created_at: a = '' }, { created_at: b = '' }): number =>
                    new Date(a) < new Date(b) ? -1 : 1,
                filters: [
                    {
                        text: 'Lab Orders',
                        value: 'labs',
                    },
                    {
                        text: 'Pharmacy Orders',
                        value: 'meds',
                    },
                ],
                onFilter: (value: string | number | boolean, order: Order): boolean =>
                    order?.type?.indexOf(value as string) === 0,
            },
            LAST_UPDATED_TIME: {
                title: (
                    <span className="font-700 text-12 text-darwin-neutral-700">
                        LAST UPDATED TIME
                    </span>
                ),
                dataIndex: 'updated_at',
                key: 'updated_at',
                width: 160,
                render: (updated_at: string, order: Order): ReactNode => {
                    const { service_id = '' } = order;
                    const { text, icon } = OrderPlacedFromObj[service_id] || {};
                    return (
                        <p className="flex items-center whitespace-nowrap text-13 space-x-4 text-darwin-neutral-900">
                            <span>{moment(updated_at).format("DD MMM'YY, hh:mm A")}</span>
                            <AntTooltip placement="bottom" content={text}>
                                <span>{icon}</span>
                            </AntTooltip>
                        </p>
                    );
                },
                sorter: ({ updated_at: a = '' }, { updated_at: b = '' }): number =>
                    new Date(a) < new Date(b) ? -1 : 1,
            },
            ORDERED_ACTION: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">ACTIONS</span>,
                width: isForLabsDeliveredColumn ? 305 : isPending ? 215 : 187.5,
                dataIndex: 'appointment_details',
                key: 'appointment_details',
                render: (appointment_details: AppointmentWithPatient, record: Order): ReactNode => {
                    const { order_details, created_at } = record;
                    if (order_details) {
                        order_details.id = order_details.order_id || '';
                        order_details.customerDetails = {
                            ...order_details.customerDetails,
                            name: appointment_details.patient.fln || '',
                        };
                    }
                    const isCancellationNotAllowed =
                        !isLabsTabActive && moment().diff(moment(created_at), 'minute') > 15;
                    return (
                        <div className="flex items-center space-x-8">
                            {isForLabsDeliveredColumn && (
                                <button
                                    className="flex items-center space-x-8 px-8 py-6 bg-neutral-9 rounded-4 border border-darwin-primary-500"
                                    onClick={() => {
                                        this.goToMedicalRecords(order_details?.patientid || '');
                                    }}
                                >
                                    <svg
                                        className="w-12 h-12 fill-darwin-primary-500"
                                        viewBox="0 0 9 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M5.15625 1.13672L8.59375 4.41797C8.69141 4.51562 8.75 4.63281 8.75 4.76953C8.75 4.88672 8.69141 5.00391 8.59375 5.10156L5.15625 8.38281C4.98047 8.55859 4.66797 8.55859 4.49219 8.36328C4.31641 8.1875 4.31641 7.875 4.51172 7.69922L7.10938 5.23828H0.46875C0.195312 5.23828 0 5.02344 0 4.76953C0 4.49609 0.195312 4.30078 0.46875 4.30078H7.10938L4.51172 1.82031C4.31641 1.64453 4.31641 1.33203 4.49219 1.15625C4.66797 0.960938 4.96094 0.960938 5.15625 1.13672Z" />
                                    </svg>
                                    <span className="text-13 font-700 text-darwin-primary-500">
                                        View Report
                                    </span>
                                </button>
                            )}

                            <button
                                className="flex items-center space-x-8 px-8 py-6 bg-neutral-9 rounded-4 border border-darwin-primary-500"
                                onClick={() => {
                                    this.showApptDialogVisible({
                                        ...appointment_details,
                                        ...record,
                                    } as AppointmentWithOrder);
                                    track('HE_DASHBOARD_VIEW_ORDER_BUTTON', {
                                        pxId: appointment_details.prescription_id || '',
                                        activeTab: this.state.activeTab,
                                    });
                                }}
                            >
                                <svg
                                    className="w-12 h-12 fill-darwin-primary-500"
                                    viewBox="0 0 9 9"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M5.15625 1.13672L8.59375 4.41797C8.69141 4.51562 8.75 4.63281 8.75 4.76953C8.75 4.88672 8.69141 5.00391 8.59375 5.10156L5.15625 8.38281C4.98047 8.55859 4.66797 8.55859 4.49219 8.36328C4.31641 8.1875 4.31641 7.875 4.51172 7.69922L7.10938 5.23828H0.46875C0.195312 5.23828 0 5.02344 0 4.76953C0 4.49609 0.195312 4.30078 0.46875 4.30078H7.10938L4.51172 1.82031C4.31641 1.64453 4.31641 1.33203 4.49219 1.15625C4.66797 0.960938 4.96094 0.960938 5.15625 1.13672Z" />
                                </svg>
                                <span className="text-13 font-700 text-darwin-primary-500">
                                    View Order
                                </span>
                            </button>

                            <AntTooltip content="Issue with Order?">
                                <button
                                    className="flex items-center justify-center h-34 px-9 bg-neutral-9 rounded-4 border border-darwin-primary-500"
                                    onClick={() => this.onNeedHelp(record)}
                                >
                                    <svg
                                        className="min-w-16 h-18 fill-darwin-primary-500"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path d="M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                                    </svg>
                                </button>
                            </AntTooltip>

                            {isPending && (
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            <OptionItem
                                                onClick={() => {
                                                    if (isCancellationNotAllowed) {
                                                        notification.error({
                                                            message:
                                                                'Cancellation not possible after 15 mins',
                                                            duration: 5,
                                                        });
                                                        return;
                                                    }
                                                    this.toggleActiveOrder(order_details);
                                                }}
                                                label={`Cancel ${
                                                    isLabsTabActive ? 'Booking' : 'Order'
                                                } `}
                                                leftIcon={
                                                    <svg
                                                        className="w-18 h-18 fill-darwin-status-warning-500"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 384 512"
                                                    >
                                                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                                                    </svg>
                                                }
                                            />
                                        </Menu>
                                    }
                                    placement="bottomLeft"
                                    arrow
                                    disabled={record?.status === CANCELLED}
                                    className="disabled:cursor-not-allowed disabled:opacity-60"
                                >
                                    <button className="flex items-center justify-center h-34 px-8 bg-neutral-9 rounded-4 border border-darwin-primary-500">
                                        <svg
                                            className="w-5 h-14 fill-darwin-primary-500"
                                            viewBox="0 0 4 13"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M2 9.59375C2.82031 9.59375 3.53125 10.3047 3.53125 11.125C3.53125 11.9727 2.82031 12.6562 2 12.6562C1.15234 12.6562 0.46875 11.9727 0.46875 11.125C0.46875 10.3047 1.15234 9.59375 2 9.59375ZM2 5.21875C2.82031 5.21875 3.53125 5.92969 3.53125 6.75C3.53125 7.59766 2.82031 8.28125 2 8.28125C1.15234 8.28125 0.46875 7.59766 0.46875 6.75C0.46875 5.92969 1.15234 5.21875 2 5.21875ZM3.53125 2.375C3.53125 3.22266 2.82031 3.90625 2 3.90625C1.15234 3.90625 0.46875 3.22266 0.46875 2.375C0.46875 1.55469 1.15234 0.84375 2 0.84375C2.82031 0.84375 3.53125 1.55469 3.53125 2.375Z" />
                                        </svg>
                                    </button>
                                </Dropdown>
                            )}
                        </div>
                    );
                },
                fixed: 'right',
            },
            ORDERED_ACTION_NEW: {
                title: (
                    <p className="font-700 text-12 text-darwin-neutral-700 text-right pr-4">
                        ACTIONS
                    </p>
                ),
                width: 220,
                key: 'appointment_details',
                render: (_, order: Order): ReactNode => {
                    const { created_at, status, type, report_document_id } = order;
                    const isCancellationNotAllowed =
                        order.status === 'cancelled' ||
                        order.status === 'delivered' ||
                        (order.type === ACTIVE_TAB.MEDS &&
                            moment().diff(moment(created_at), 'minute') > 15);
                    const isReportDelivered = type === ACTIVE_TAB.LABS && status === 'delivered';
                    const mrUrl =
                        GO_TO_PATIENTS_DETAILS(order?.patient_id || '', 'medical-records') +
                        `${report_document_id ? `?report_document_id=${report_document_id}` : ''}`;
                    return (
                        <div className="flex items-center justify-end">
                            <button
                                className="text-13 font-700 text-darwin-accent-bright-blue-800 px-8 py-6"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (isReportDelivered) {
                                        window.open(mrUrl, '_blank');
                                        track('HE_DASHBOARD_VIEW_REPORT_BUTTON', {
                                            orderId: order.order_id || '',
                                        });
                                    } else {
                                        this.showApptDialogVisible(
                                            (order as unknown) as AppointmentWithOrder,
                                        );
                                        track('HE_DASHBOARD_VIEW_ORDER_BUTTON', {
                                            pxId: order.prescription_id || '',
                                            activeTab: this.state.activeTab,
                                        });
                                    }
                                }}
                            >
                                {isReportDelivered ? 'View Report' : 'Track Order'}
                            </button>

                            <button
                                className="text-13 font-700 text-darwin-accent-bright-blue-800 px-8 py-6"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.onNeedHelp(order);
                                }}
                            >
                                Need Help?
                            </button>

                            <MoreOptionsDropdown
                                order={order}
                                activeTab={this.state.activeTab}
                                isCancellationNotAllowed={isCancellationNotAllowed}
                                toggleEditOrder={this.toggleEditOrder}
                                toggleActiveOrder={this.toggleActiveOrder}
                                showApptDialogVisible={this.showApptDialogVisible}
                            />
                        </div>
                    );
                },
                fixed: 'right',
            },
            NOT_ORDERED_ACTION: {
                title: <span className="font-700 text-12 text-darwin-neutral-700">ACTIONS</span>,
                dataIndex: 'appointment_details',
                key: 'appointment_details',
                width: 340,
                render: (appointment_details: AppointmentWithPatient): ReactNode => {
                    const isNonHXNGDoctor = !isOnboardedForPharma() && !isOnboardedForLab();
                    const hidePlaceOrderButton =
                        (isRXMonetisationT1() || isRXMonetisationT2()) && isNonHXNGDoctor;
                    return (
                        <div className="flex items-center space-x-10">
                            {!hidePlaceOrderButton && (
                                <button
                                    className="flex items-center space-x-10 px-18 py-6 bg-neutral-9 rounded-4 border border-darwin-primary-500"
                                    onClick={() => {
                                        this.componentWillUnmount();
                                        this.showApptDialogVisible(
                                            appointment_details as AppointmentWithOrder,
                                        );
                                        track('HE_DASHBOARD_PLACE_ORDER_BUTTON', {
                                            pxId: appointment_details.prescription_id || '',
                                            activeTab: this.state.activeTab,
                                        });
                                    }}
                                >
                                    <svg
                                        className="w-12 h-12 fill-darwin-primary-500"
                                        viewBox="0 0 9 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M5.15625 1.13672L8.59375 4.41797C8.69141 4.51562 8.75 4.63281 8.75 4.76953C8.75 4.88672 8.69141 5.00391 8.59375 5.10156L5.15625 8.38281C4.98047 8.55859 4.66797 8.55859 4.49219 8.36328C4.31641 8.1875 4.31641 7.875 4.51172 7.69922L7.10938 5.23828H0.46875C0.195312 5.23828 0 5.02344 0 4.76953C0 4.49609 0.195312 4.30078 0.46875 4.30078H7.10938L4.51172 1.82031C4.31641 1.64453 4.31641 1.33203 4.49219 1.15625C4.66797 0.960938 4.96094 0.960938 5.15625 1.13672Z" />
                                    </svg>
                                    <span className="text-13 font-700 text-darwin-primary-500">
                                        Place Order
                                    </span>
                                </button>
                            )}
                            <button
                                className="flex items-center space-x-10 px-18 py-6 bg-neutral-9 rounded-4 border border-darwin-primary-500"
                                onClick={() =>
                                    this.viewPrescription(appointment_details.prescription_id)
                                }
                            >
                                <svg
                                    className="w-12 h-12 fill-darwin-primary-500"
                                    viewBox="0 0 9 11"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M6.26953 7.625L8.59375 5.30078C8.78906 5.125 8.78906 4.83203 8.59375 4.65625C8.41797 4.46094 8.125 4.46094 7.92969 4.65625L5.625 6.98047L3.75 5.10547C4.80469 4.94922 5.625 4.05078 5.625 2.9375C5.625 1.74609 4.62891 0.75 3.4375 0.75H0.46875C0.195312 0.75 0 0.964844 0 1.21875V6.55078C0 6.80469 0.195312 7.01953 0.449219 7.01953C0.683594 7.01953 0.9375 6.80469 0.9375 6.53125V5.125H2.46094L4.96094 7.625L2.63672 9.94922C2.44141 10.1445 2.44141 10.4375 2.63672 10.6133C2.71484 10.7109 2.83203 10.75 2.96875 10.75C3.08594 10.75 3.20312 10.7109 3.28125 10.6133L5.625 8.28906L7.94922 10.6133C8.02734 10.7109 8.14453 10.75 8.28125 10.75C8.39844 10.75 8.51562 10.7109 8.59375 10.6133C8.78906 10.4375 8.78906 10.1445 8.59375 9.96875L6.26953 7.625ZM0.9375 1.6875H3.4375C4.12109 1.6875 4.6875 2.25391 4.6875 2.9375C4.6875 3.64062 4.12109 4.1875 3.4375 4.1875H0.9375V1.6875Z" />
                                </svg>

                                <span className="text-13 font-700 text-darwin-primary-500">
                                    View Prescription
                                </span>
                            </button>
                        </div>
                    );
                },
                fixed: 'right',
            },
        };
        const isForLabsOrderStatusColumn = isPending && isLabsTabActive;
        if (!isForLabsOrderStatusColumn) delete columns['ORDER_STATUS'].filters;
        return columnArray.map((i) => columns[i]);
    };

    renderComponent = (transactions: Order[]): ReactNode => {
        const { orderStatusFilter } = this.props.match.params;
        const { activeTab } = this.state;
        const SLOT_DETAILS = activeTab === ACTIVE_TAB.LABS ? 'SLOT_DETAILS' : '';
        let columns: string[] = [];

        if (activeTab === ACTIVE_TAB.ALL_ORDERS) {
            columns = [
                'PATIENT_DETAILS_NEW',
                'ORDER_PLACED_NEW',
                'ORDER_STATUS_NEW',
                'REMARKS',
                'LAST_UPDATED_TIME',
                'AMOUNT',
                'ORDERED_ACTION_NEW',
            ];
        } else if (orderStatusFilter === 'not-ordered')
            columns = [
                'SEQ',
                'PATIENT_DETAILS',
                'CONTACT',
                'VISITED_ON',
                'ORDER_STATUS',
                'NOT_ORDERED_ACTION',
            ];
        else if (orderStatusFilter === 'pending' || orderStatusFilter === 'delivered')
            columns = [
                'SEQ',
                'PATIENT_DETAILS',
                'CONTACT',
                'ORDER_PLACED',
                'ORDER_STATUS',
                'PAYMODE',
                'AMOUNT',
                SLOT_DETAILS,
                'ORDERED_ACTION',
            ].filter(Boolean);

        return this.state.fetchState === 'loading' ? (
            <div className="h-full flex items-center justify-center">
                <svg
                    className="w-24 h-24 fill-actionPrimary animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                >
                    <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                </svg>
            </div>
        ) : this.state.fetchState !== 'error' && transactions.length ? (
            <Table
                columns={this.buildColumns(columns)}
                className="order-medicines-dashboard"
                dataSource={transactions}
                pagination={false}
                sticky={true}
                scroll={{
                    x: 1300,
                }}
                key={this.state.tableKey}
                onRow={(order: Order) => ({
                    onClick: () => {
                        if (activeTab !== ACTIVE_TAB.ALL_ORDERS) return;
                        this.showApptDialogVisible((order as unknown) as AppointmentWithOrder);
                        track('HE_DASHBOARD_VIEW_ORDER_ROW', {
                            pxId: order.prescription_id || '',
                            activeTab: this.state.activeTab,
                        });
                    },
                })}
                rowClassName={
                    activeTab === ACTIVE_TAB.ALL_ORDERS
                        ? 'cursor-pointer hover:bg-darwin-accent-bright-blue-100'
                        : ''
                }
            />
        ) : this.state.fetchState === 'error' ? (
            <FetchError onRefresh={this.getAllTransactions} activeTab={this.state.activeTab} />
        ) : (
            <EmptyView activeTab={this.state.activeTab} />
        );
    };

    exportAsExcel = (): void => {
        const xlsx = document.createElement('script');
        xlsx.onload = this.createExcelAndDownload;
        xlsx.src = '/xlsx-sheet.js';
        document.getElementsByTagName('head')[0].appendChild(xlsx);
    };

    createExcelAndDownload = (): void => {
        const { activeTab } = this.state;
        track('EXPORT_EXCEL_HE_DASHBOARD', {
            activeTab,
        });

        const requiredData = this.allTransactions
            .filter((i) => i.status !== 'not ordered')
            .map((t, i) => {
                return {
                    'Sr No': i + 1,
                    'Order ID': t.order_details?.id,
                    'Order Status': t.status === 'init' ? 'Order Placed' : 'Order Delivered',
                    Amount: t.order_details?.paidAmount,
                    Discount: t.platformdiscount + '%',
                    'Patient Name': getPatientNameText(t.patient),
                    Mobile: t.patient.mobile,
                    Pincode: t.order_details?.address?.pincode,
                };
            });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const ws = XLSX.utils.json_to_sheet(requiredData);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const wb = XLSX.utils.book_new();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XLSX.utils.book_append_sheet(wb, ws, 'Eka Billing');

        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();

        const start = moment(startDate).format('DD-MM-YYYY');
        const end = moment(endDate).format('DD-MM-YYYY');

        const filename = `Eka-${
            activeTab === ACTIVE_TAB.MEDS ? 'Medicine' : 'Lab-Test'
        }-Orders-${start}-to-${end}.xls`;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        XLSX.writeFile(wb, filename);
    };

    showApptDialogVisible = (appt: AppointmentWithOrder, isForEditOrder?: boolean): void => {
        this.setState({
            apptDialogVisible: appt,
            isForEditOrder: isForEditOrder,
        });
    };

    hideApptDialogVisible = (): void => {
        this.setState({
            apptDialogVisible: undefined,
            isForEditOrder: undefined,
        });
    };

    viewPrescription = (prescription_id?: string | null): void => {
        const url = getPxPrintUrl(prescription_id || '');
        window.open(url);
    };

    tabChangeHandler = (newTab: ActiveTab) => {
        const { activeTab } = this.state;
        const { startDate, endDate } = this.getStartDateAndEndDateFromUrl();
        const { orderStatusFilter } = this.props.match.params;

        if (activeTab === newTab) return;

        this.setState({
            ...this.initialState,
            activeTab: newTab,
            fetchState: 'loading',
            lastUpdated: new Date().toISOString(),
        });
        this.fetchTransactions(startDate, endDate, orderStatusFilter, newTab);
        track('HE_DASHBOARD_TOGGLE_BUTTON', { activeTab: newTab });
    };

    getMessageForMissingDetailsInOnboarding = () => {
        const { missingDetailsInOnboarding = [] } = this.state;
        return (
            <p>
                Warning: Please submit your{' '}
                {[
                    missingDetailsInOnboarding.includes('bank') && 'bank details',
                    missingDetailsInOnboarding.includes('pancard') && 'pancard details',
                ]
                    .filter(Boolean)
                    .join(' and ')}{' '}
                to receive timely payouts!
            </p>
        );
    };

    goToHEOnboarding = (): void => {
        const { history } = this.props;
        const { missingDetailsInOnboarding = [] } = this.state;

        if (missingDetailsInOnboarding.includes('bank')) {
            history.replace(GO_TO_HE_ONBOARDING('bank'));
            track('FILL_ONBOARDING_DETAILS_WARNING_BUTTON', { what: 'bank' });
        } else if (missingDetailsInOnboarding.includes('pancard')) {
            history.replace(GO_TO_HE_ONBOARDING('pancard'));
            track('FILL_ONBOARDING_DETAILS_WARNING_BUTTON', { what: 'pancard' });
        }
    };

    onSettings = (): void => {
        const { history } = this.props;
        history.replace(GO_TO_HE_ONBOARDING('home'));
        track('HE_DASHBOARD_ON_SETTINGS');
    };

    toggleActiveOrder = (order?: OrderDetails) => {
        const { activeTab } = this.state;
        if (order?.status === 'cancelled') {
            notification.error({
                message: `Error: ${
                    activeTab === ACTIVE_TAB.MEDS ? 'Order' : 'Booking'
                } already cancelled!`,
                duration: 5,
                placement: 'topRight',
            });
            return;
        }
        this.setState({
            activeOrder: order,
        });
        if (order) {
            track('CANCEL_ORDER_OR_BOOKING', {
                from: 'he dashboard',
                activeTab,
                order_id: order?.id,
            });
        }
    };

    getPayoutsDetails = async () => {
        try {
            const { payouts, latestPayoutAmount } = await getPayouts();
            if (payouts && payouts.length) {
                this.setState({
                    payouts,
                    latestPayoutAmount,
                });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getPayouts',
                error: (error as Error).message,
            });
        }
    };

    togglePayoutsModal = () => {
        const { isPayoutsModalVisible, payouts = [] } = this.state;
        this.setState({
            isPayoutsModalVisible: !isPayoutsModalVisible,
        });
        track('TOGGLE_PAYOUTS_MODAL', {
            action: isPayoutsModalVisible ? 'close' : 'open',
            totalPayouts: String(payouts.length),
        });
    };

    toggleBankAccountsModal = () => {
        const { isBankAccountsModalVisible } = this.state;
        this.setState({
            isBankAccountsModalVisible: !isBankAccountsModalVisible,
        });
        track('TOGGLE_BANK_ACCOUNTS_MODAL', {
            action: isBankAccountsModalVisible ? 'close' : 'open',
        });
    };

    handleClick = (key: TimeFilterType) => {
        const { startDate, endDate } = timeFiltersObj[key];
        this.setTimeFilter(startDate, endDate);
        this.setState({
            currTimeFilter: timeFiltersObj[key].label,
            dates: undefined,
        });
    };

    daysFilter = () => (
        <Menu className="w-184 rounded-8 pt-0">
            <div className="font-lato border-b border-darwin-neutral-100 flex gap-8 py-8 px-16 text-13 items-center font-700">
                <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.5 2.00391C0.5 1.41992 0.957031 0.9375 1.54102 0.9375H12.4336C13.0176 0.9375 13.5 1.41992 13.5 2.00391C13.5 2.25781 13.3984 2.48633 13.2461 2.66406L9.03125 7.86914V11.5C9.03125 11.957 8.65039 12.3125 8.19336 12.3125C8.01562 12.3125 7.83789 12.2617 7.68555 12.1348L5.34961 10.2812C5.0957 10.0781 4.96875 9.79883 4.96875 9.49414V7.86914L0.728516 2.66406C0.576172 2.48633 0.5 2.25781 0.5 2.00391ZM1.87109 2.15625L6.03516 7.25977C6.13672 7.38672 6.1875 7.51367 6.1875 7.64062V9.39258L7.8125 10.6875V7.64062C7.8125 7.51367 7.83789 7.38672 7.93945 7.25977L12.1035 2.15625H1.87109Z"
                        fill="#484848"
                    />
                </svg>
                Filter
            </div>
            {Object.entries(timeFiltersObj).map(([k, v]) => (
                <Menu.Item className="py-8 px-16">
                    <Radio
                        defaultChecked={v.label === timeFiltersObj['last-7-days'].label}
                        value={v.label}
                        onClick={() => this.handleClick(k as TimeFilterType)}
                        disabled={this.state.fetchState === 'loading'}
                        checked={v.label === this.state.currTimeFilter}
                        className={`${
                            v.label === this.state.currTimeFilter
                                ? 'filter-radio'
                                : 'add-new-pt-radio'
                        }`}
                    >
                        <p
                            className={`select-none font-lato text-neutral-black text-400 text-13 ${
                                v.label === this.state.currTimeFilter && 'font-700'
                            }`}
                        >
                            {v.label}
                        </p>
                    </Radio>
                </Menu.Item>
            ))}
        </Menu>
    );

    goToMedicalRecords = (patientid: string): void => {
        const { history } = this.props;
        history.replace(GO_TO_PATIENTS_DETAILS(patientid, 'medical-records'));
    };

    toggleFeelGoodData = () => {
        const { showFeelGoodData } = this.state;
        this.setState({
            showFeelGoodData: !showFeelGoodData,
        });
        track('TOGGLE_FEEL_GOOD_DATA', { action: showFeelGoodData ? 'CLOSE' : 'OPEN' });
    };

    onNeedHelp = (record: Order) => {
        const { order_id, status, sub_status } = record;
        openCrispChat(
            'NEED_HELP_HXNG',
            {
                from: 'Order Dashboard',
                type: record.type === ACTIVE_TAB.MEDS ? 'pharma' : 'lab',
                order_id,
                status,
                sub_status: sub_status,
            },
            `I have an issue with this ${
                record.type === ACTIVE_TAB.MEDS ? 'Pharma' : 'Lab'
            } order  - ${order_id} - Status : ${capitalize(status)} ${
                sub_status ? `(${capitalize(sub_status)})` : ''
            }`,
        );
    };

    getStatusFilters = (transactions: Order[]) => {
        const statusFilters = [];
        const obj: { [k: string]: number } = {};
        transactions.forEach((i) => {
            const key = i.sub_status || i.status || '';
            if (obj[key]) obj[key] += 1;
            else obj[key] = 1;
        });
        const status_obj: { [k: string]: string } = {
            init: 'Order Placed',
            rescheduled: 'Rescheduled',
            cancelled: 'Cancelled',
            phleboassigned: 'Pickup',
            pickup: 'Sample Collected',
            partially_delivered: 'Partially Delivered',
            delivered: 'Delivered',
            redeliver: 'Redeliver',
            packaging: 'Packaging',
            out_for_delivery: 'Out for Delivery',
            order_dispatched: 'Dispatched',
            order_stuck: 'Order Stuck',
        };
        for (const key in obj) {
            statusFilters.push({ status: key, label: status_obj[key] || key, count: obj[key] });
        }
        return statusFilters.sort((a, b) => b.count - a.count);
    };

    toggleStatusFilters = (status: string): void => {
        const { statusFiltersSet } = this.state;
        if (statusFiltersSet.has(status)) statusFiltersSet.delete(status);
        else statusFiltersSet.add(status);
        this.setState({
            statusFiltersSet: new Set([...statusFiltersSet]),
        });
    };

    clearFilters = () => {
        this.setState({
            statusFiltersSet: new Set(),
        });
    };

    toggleEditOrder = (order?: Order) => {
        this.setState({
            editOrder: order,
        });
    };

    getValueFromOrder = () => {
        const { editOrder } = this.state;
        if (!editOrder) {
            return {
                vendor: '',
                vendor_id: '',
                addressFormInput: ADDRESS_FORM_INPUT,
                selectedSlotDetails: {
                    collection_date: '',
                    collection_slot: {
                        id: 0,
                        details: {
                            start_time: '',
                            end_time: '',
                        },
                    },
                },
            };
        }
        const {
            vendorname,
            vendorid,
            customer_details,
            collection_date,
            collection_slot,
        } = editOrder;
        const vendor = vendorname || '';
        const vendor_id = vendorid || '';
        const addressFormInput = customer_details?.address_details as AddressFormInput;
        const selectedSlotDetails = {
            collection_date,
            collection_slot,
        } as SelectedSlotDetails;
        return { vendor, vendor_id, addressFormInput, selectedSlotDetails };
    };

    render(): ReactNode {
        const {
            fetchState,
            filteredTransactions,
            searchFilter,
            lastUpdated,
            activeTab,
            switchColumn,
            missingDetailsInOnboarding,
            activeOrder,
            payouts,
            latestPayoutAmount,
            isPayoutsModalVisible,
            isBankAccountsModalVisible,
            showFeelGoodData,
            statusFiltersSet,
            editOrder,
            isForEditOrder,
        } = this.state;
        const { orderStatusFilter } = this.props.match.params;
        const { counts } = this;
        const apptDialogVisible = (this.state
            .apptDialogVisible as unknown) as AppointmentWithPatient;
        const currentOrder = (this.state.apptDialogVisible as unknown) as Order;

        let gen = apptDialogVisible?.patient?.gen;

        if (gen === 'M') gen = 'male';
        else if (gen === 'F') gen = 'female';
        else gen = 'others';

        const age = getAgeInYears({ dob: apptDialogVisible?.patient?.dob }) || 18;
        const clinics = getSingleDoctor()?.profile.professional.clinics || [];
        const currentClinicId = apptDialogVisible?.clinic_id;
        const currentClinic = clinics.find((i) => i._id === currentClinicId);

        let transactions: Order[] = filteredTransactions;
        const _name = searchFilter;
        const _phone = `${searchFilter.replaceAll(' ', '')}`;
        if (searchFilter) {
            transactions = this.transactionsFuse
                .search({
                    $or: [{ _name }, { _phone }],
                })
                .map((i) => i.item);
        }
        const statusFilters = this.getStatusFilters(transactions);
        if (statusFiltersSet.size > 0) {
            transactions = transactions.filter((i) =>
                statusFiltersSet.has(i?.sub_status || i?.status),
            );
        }

        const showMissingDetailsInOnboardingStrip =
            missingDetailsInOnboarding && missingDetailsInOnboarding.length > 0;

        const latestPayoutDeatils = payouts && payouts[0];

        const totalOrders = filteredTransactions.length;

        const pxId = currentOrder?.pxid || '';
        const patientId = currentOrder?.patient_id || '';
        const patientName = currentOrder?.patient_name || '';
        const phoneNumber = currentOrder?.customer_details?.mobile || '';
        const gender = currentOrder?.customer_details?.gender?.[0]?.toUpperCase() || '';
        const ageInOrder = currentOrder?.customer_details?.age || 0;
        const orderId = currentOrder?.order_id;
        const {
            vendor,
            vendor_id,
            addressFormInput,
            selectedSlotDetails,
        } = this.getValueFromOrder();

        return (
            <div className="flex flex-col w-full h-full bg-white font-lato">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>EKA - All HE Orders</title>
                </Helmet>

                <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
                    <LeftBar />
                    <div className="flex flex-col h-full col-span-11 overflow-hidden">
                        <NewHeaderComponent
                            title="Orders"
                            filterComponent={
                                <div className="flex w-full justify-between items-stretch gap-8">
                                    <div className="flex relative top-2 items-center gap-4">
                                        <p className="text-neutral-5 text-13">
                                            Last updated at {moment(lastUpdated).format('hh:mm A')}
                                        </p>
                                        <AntTooltip content="Refresh">
                                            <div className="flex justify-between p-4 select-none items-center space-x-16">
                                                <div className="flex space-x-8 items-center">
                                                    <button
                                                        onClick={this.getAllTransactions}
                                                        className="flex space-x-8 items-center border-b border-transparent cursor-pointer text-actionPrimary hover:text-actionPrimary-hover hover:border-actionPrimary-hover font-700 focus:outline-none text-14"
                                                    >
                                                        <svg
                                                            width="12"
                                                            height="12"
                                                            className="fill-darwin-accent-bright-blue-800"
                                                            viewBox="0 0 512 512"
                                                        >
                                                            <path d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88C178.39 88.068 111.52 141.178 93.057 214.85C91.713 220.213 86.935 224 81.406 224H24.103C16.605 224 10.909 217.193 12.296 209.824C33.933 94.924 134.813 8 256 8C322.448 8 382.791 34.136 427.315 76.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192C504 205.255 493.255 216 480 216H345.941C324.559 216 313.851 190.149 328.97 175.029L370.72 133.28V133.28ZM32 296H166.059C187.441 296 198.149 321.851 183.03 336.971L141.28 378.721C172.542 407.994 213.115 424.04 256.156 424.001C333.574 423.931 400.471 370.857 418.943 297.152C420.287 291.789 425.065 288.002 430.594 288.002H487.898C495.396 288.002 501.092 294.809 499.705 302.178C478.067 417.076 377.187 504 256 504C189.552 504 129.209 477.864 84.685 435.315L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320C8 306.745 18.745 296 32 296Z"></path>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </AntTooltip>
                                    </div>
                                    <div className="flex gap-8 h-36 items-stretch">
                                        <AntTooltip content="Settings">
                                            {isDoctor() && (
                                                <button
                                                    className="bg-darwin-neutral_new-50 w-36 p-6 cursor-pointer flex items-center gap-8 text-neutral-black font-400 text-13 justify-center px-12 py-4 rounded-8"
                                                    onClick={this.onSettings}
                                                >
                                                    {settingsIcon2('w-17 flex-shrink-0')}
                                                </button>
                                            )}
                                        </AntTooltip>
                                        <DateFilter
                                            currTimeFilter={this.state.currTimeFilter}
                                            daysFilter={this.daysFilter}
                                            setTimeFilter={(startDate: string, endDate: string) => {
                                                this.setState({
                                                    currTimeFilter: 'Custom',
                                                });
                                                this.setTimeFilter(startDate, endDate);
                                            }}
                                            datePickerDisabled={this.state.fetchState === 'loading'}
                                            noOfDays={90}
                                            dates={this.state.dates}
                                            setDates={(val) => this.setState({ dates: val })}
                                        />
                                        {activeTab === ACTIVE_TAB.ALL_ORDERS && amIDoctorOnly() && (
                                            <button
                                                className="flex items-center space-x-8 px-16 py-6 text-white bg-darwin-accent-bright-blue-800 font-700 rounded-8"
                                                onClick={this.togglePayoutsModal}
                                            >
                                                <p className="text-16">₹</p>
                                                <p>Payouts Report</p>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            }
                        />

                        <div className="flex pl-16 space-x-4 bg-darwin-neutral_new-50 cursor-pointer text-darwin-neutral-900 select-none">
                            <button
                                className={`h-full flex items-center space-x-8 px-16 pt-10 ${
                                    activeTab === ACTIVE_TAB.ALL_ORDERS
                                        ? 'border-b-2 pb-8 border-darwin-accent-bright-blue-800 font-700 text-darwin-accent-bright-blue-800'
                                        : 'font-700 py-10 text-darwin-neutral-900'
                                }`}
                                onClick={() => this.tabChangeHandler(ACTIVE_TAB.ALL_ORDERS)}
                                disabled={fetchState === 'loading'}
                            >
                                <p className="whitespace-nowrap">
                                    All Orders{' '}
                                    {activeTab === ACTIVE_TAB.ALL_ORDERS && totalOrders > 0
                                        ? `(${totalOrders})`
                                        : ''}
                                </p>
                            </button>
                            <button
                                className={`h-full flex items-center space-x-8 px-16 pt-10 ${
                                    activeTab === ACTIVE_TAB.LABS
                                        ? 'border-b-2 pb-8 border-darwin-accent-bright-blue-800 font-700 text-darwin-accent-bright-blue-800'
                                        : 'font-700 py-10 text-darwin-neutral-900'
                                }`}
                                onClick={() => this.tabChangeHandler(ACTIVE_TAB.LABS)}
                                disabled={fetchState === 'loading'}
                            >
                                <p className="whitespace-nowrap">Appointments</p>
                            </button>
                            {/* <button
                                className={`h-full flex items-center space-x-8 px-16 pt-10 ${
                                    activeTab === ACTIVE_TAB.MEDS
                                        ? 'border-b-2 pb-8 border-darwin-accent-bright-blue-800 font-700 text-darwin-accent-bright-blue-800'
                                        : 'font-700 py-10 text-darwin-neutral-900'
                                }`}
                                onClick={() => this.tabChangeHandler(ACTIVE_TAB.MEDS)}
                                disabled={fetchState === 'loading'}
                            >
                                <p className="whitespace-nowrap">Pharmacy</p>
                            </button> */}
                        </div>

                        {isDoctor() && showMissingDetailsInOnboardingStrip && (
                            <Alert
                                message={this.getMessageForMissingDetailsInOnboarding()}
                                showIcon
                                type="warning"
                                action={
                                    <button
                                        className="text-13 font-700 px-14 py-4 rounded-4 bg-darwin-status-warning-500 text-white"
                                        onClick={this.goToHEOnboarding}
                                    >
                                        Submit Details
                                    </button>
                                }
                            />
                        )}

                        <div
                            className={`flex ${
                                activeTab === ACTIVE_TAB.ALL_ORDERS
                                    ? fetchState !== 'loading' && statusFilters.length === 0
                                        ? 'mt-8'
                                        : 'items-center pt-10 pb-8'
                                    : 'items-end'
                            } justify-between space-x-8`}
                        >
                            {activeTab === ACTIVE_TAB.ALL_ORDERS ? (
                                <div className="flex items-center space-x-16 px-16 whitespace-nowrap overflow-auto">
                                    {fetchState === 'loading' ? (
                                        <Fragment>
                                            <button className="flex items-center space-x-8 border px-12 rounded-8 text-13 py-6 border-darwin-neutral_new-200 h-34 w-120 shimmer"></button>
                                            <button className="flex items-center space-x-8 border px-12 rounded-8 text-13 py-6 border-darwin-neutral_new-200 h-34 w-120 shimmer"></button>
                                            <button className="flex items-center space-x-8 border px-12 rounded-8 text-13 py-6 border-darwin-neutral_new-200 h-34 w-120 shimmer"></button>
                                        </Fragment>
                                    ) : (
                                        statusFilters.map((i) => (
                                            <button
                                                className={`flex items-center space-x-8 border px-12 rounded-8 text-13 py-6 ${
                                                    statusFiltersSet.has(i.status)
                                                        ? 'border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-100 font-700'
                                                        : 'border-darwin-neutral_new-200'
                                                }`}
                                                onClick={() => this.toggleStatusFilters(i.status)}
                                            >
                                                <p>
                                                    {i.label} ({i.count})
                                                </p>
                                                {statusFiltersSet.has(i.status) && (
                                                    <p>
                                                        <svg
                                                            className="w-12 h-12"
                                                            viewBox="0 0 12 12"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                                                                fill="#1A1A1A"
                                                            />
                                                        </svg>
                                                    </p>
                                                )}
                                            </button>
                                        ))
                                    )}
                                    {statusFiltersSet.size > 0 && (
                                        <p
                                            className="text-13 font-700 text-darwin-accent-bright-blue-800 underline cursor-pointer"
                                            onClick={this.clearFilters}
                                        >
                                            Clear filters
                                        </p>
                                    )}
                                </div>
                            ) : (
                                <HEDashboardStatusFilters
                                    data={counts}
                                    isLoading={fetchState === 'loading'}
                                    setFilter={this.setOrderFilter}
                                    orderStatusFilter={orderStatusFilter}
                                    activeTab={activeTab}
                                    transactions={this.allTransactions}
                                    toggleFeelGoodData={this.toggleFeelGoodData}
                                    showFeelGoodData={Boolean(showFeelGoodData)}
                                />
                            )}

                            {activeTab !== ACTIVE_TAB.ALL_ORDERS && (
                                <div className="flex items-center space-x-16 pr-16 pb-16 whitespace-nowrap">
                                    {amIDoctorOnly() && (
                                        <button
                                            className="flex items-center space-x-8 px-15 py-5 text-darwin-accent-bright-blue-800 border border-darwin-accent-bright-blue-800 font-700 rounded-4"
                                            onClick={this.toggleBankAccountsModal}
                                        >
                                            <p className="text-16">₹</p>
                                            <p>Bank Accounts</p>
                                        </button>
                                    )}
                                    {amIDoctorOnly() && (
                                        <button
                                            className="flex items-center space-x-8 px-16 py-6 text-white bg-darwin-accent-bright-blue-800 font-700 rounded-4"
                                            onClick={this.togglePayoutsModal}
                                        >
                                            <p className="text-16">₹</p>
                                            <p>Payouts Report</p>
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                        {activeTab !== ACTIVE_TAB.ALL_ORDERS &&
                            latestPayoutDeatils &&
                            Boolean(latestPayoutAmount) && (
                                <div className="grid grid-cols-2">
                                    <div
                                        className="flex items-center space-x-16 mx-16 px-12 py-6 cursor-pointer bg-gradient-to-r from-status-infoBG text-status-info select-none font-700"
                                        onClick={this.togglePayoutsModal}
                                    >
                                        <p className="px-10 py-4 rounded-6 border border-status-info">
                                            Announcement
                                        </p>
                                        <p className="space-x-5">
                                            <span>
                                                {moment(latestPayoutDeatils.created_at).format(
                                                    'MMMM',
                                                )}{' '}
                                                Payout
                                            </span>
                                            <span>:</span>
                                            <span>₹ {latestPayoutAmount}/-</span>
                                        </p>
                                    </div>
                                    <div
                                        className="flex items-center justify-end space-x-16 mx-16 px-12 py-6 cursor-pointer bg-gradient-to-l from-status-infoBG text-status-info select-none font-700"
                                        onClick={this.togglePayoutsModal}
                                    >
                                        <p>
                                            Monthly Payout Report Available{' '}
                                            <span className="text-20 pl-4">☝️</span>
                                        </p>
                                    </div>
                                </div>
                            )}
                        <div className="px-16 flex-1 flex flex-col pb-16">
                            <div className="flex flex-col flex-1 w-full mt-4 overflow-hidden border rounded-4 border-neutral-7">
                                <div className="flex items-center justify-between w-full pl-6 pr-16 py-8 bg-neutral-9">
                                    <div className="flex items-center space-x-12 w-50p">
                                        <div className="relative flex items-center px-8 space-x-8 bg-white border border-neutral-7 rounded-2 w-40p">
                                            <div className="flex items-center justify-center w-16 h-16">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-16 h-16 fill-neutral-6"
                                                >
                                                    <path d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path>
                                                </svg>
                                            </div>
                                            <input
                                                type="search"
                                                name="ether-search-component"
                                                onChange={this.onSearchInputChange}
                                                value={searchFilter}
                                                autoComplete="off"
                                                className="w-full py-4 bg-transparent focus:outline-none placeholder-neutral-6 text-11 input-cancelable-on-filled"
                                                placeholder="Search by Phone / Name"
                                            />
                                            <div className="absolute inset-0 pointer-events-none"></div>
                                            <div
                                                className="absolute flex items-center justify-center w-16 h-16 transform -translate-y-1/2 right-8 top-1/2 cancel-icon"
                                                onClick={this.clearSearchFilter}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    className="w-12 h-12 fill-neutral-black"
                                                >
                                                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    {activeTab !== ACTIVE_TAB.ALL_ORDERS && (
                                        <div className="flex items-center space-x-18">
                                            <p
                                                onClick={this.exportAsExcel}
                                                className="cursor-pointer text-actionPrimary font-700 text-13"
                                            >
                                                Export as Excel
                                            </p>
                                        </div>
                                    )}
                                </div>
                                <div className="relative flex-1 w-full table-fader">
                                    {switchColumn === 'loading' && (
                                        <div className="flex items-center justify-center absolute inset-0 z-10 bg-white">
                                            <svg
                                                className="w-24 h-24 fill-actionPrimary animate-spin"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                            >
                                                <path d="M96 256c0-26.5-21.5-48-48-48S0 229.5 0 256s21.5 48 48 48S96 282.5 96 256zM108.9 60.89c-26.5 0-48.01 21.49-48.01 47.99S82.39 156.9 108.9 156.9s47.99-21.51 47.99-48.01S135.4 60.89 108.9 60.89zM108.9 355.1c-26.5 0-48.01 21.51-48.01 48.01S82.39 451.1 108.9 451.1s47.99-21.49 47.99-47.99S135.4 355.1 108.9 355.1zM256 416c-26.5 0-48 21.5-48 48S229.5 512 256 512s48-21.5 48-48S282.5 416 256 416zM464 208C437.5 208 416 229.5 416 256s21.5 48 48 48S512 282.5 512 256S490.5 208 464 208zM403.1 355.1c-26.5 0-47.99 21.51-47.99 48.01S376.6 451.1 403.1 451.1s48.01-21.49 48.01-47.99S429.6 355.1 403.1 355.1zM256 0C229.5 0 208 21.5 208 48S229.5 96 256 96s48-21.5 48-48S282.5 0 256 0z"></path>
                                            </svg>
                                        </div>
                                    )}
                                    <div className="absolute inset-0 overflow-y-scroll">
                                        {this.renderComponent(transactions)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AnimatePresence>
                    {apptDialogVisible &&
                        activeTab !== ACTIVE_TAB.ALL_ORDERS &&
                        (activeTab === ACTIVE_TAB.MEDS ? (
                            <OrderMedicineDialog
                                closeMe={this.hideApptDialogVisible}
                                formData={apptDialogVisible.formData || []}
                                pxid={apptDialogVisible.prescription_id || ''}
                                patientId={apptDialogVisible.patient_oid || ''}
                                name={apptDialogVisible.patient.fln || ''}
                                phone={apptDialogVisible.patient.mobile?.replace('+91', '') || ''}
                                gender={gen}
                                age={age}
                                clinicPin={currentClinic?.address?.pin || ''}
                                orderId={((apptDialogVisible as unknown) as Order).order_id}
                            />
                        ) : activeTab === ACTIVE_TAB.LABS ? (
                            <BookLabTestsDialog
                                closeMe={this.hideApptDialogVisible}
                                formData={apptDialogVisible.formData || []}
                                pxid={apptDialogVisible.prescription_id || ''}
                                patientid={apptDialogVisible.patient_oid || ''}
                                name={apptDialogVisible.patient.fln || ''}
                                phone={apptDialogVisible.patient.mobile?.replace('+91', '') || ''}
                                gender={gen}
                                age={age}
                                orderId={((apptDialogVisible as unknown) as Order).order_id}
                            />
                        ) : null)}
                </AnimatePresence>

                <AnimatePresence>
                    {apptDialogVisible &&
                        activeTab === ACTIVE_TAB.ALL_ORDERS &&
                        (currentOrder.type === ACTIVE_TAB.MEDS ? (
                            <OrderMedicineDialog
                                closeMe={this.hideApptDialogVisible}
                                formData={[]}
                                pxid={pxId}
                                patientId={patientId}
                                name={patientName}
                                phone={phoneNumber}
                                gender={gender}
                                age={ageInOrder}
                                clinicPin={currentClinic?.address?.pin || ''}
                                orderId={orderId}
                            />
                        ) : currentOrder.type === ACTIVE_TAB.LABS ? (
                            <BookLabTestsDialog
                                closeMe={this.hideApptDialogVisible}
                                formData={[]}
                                pxid={pxId}
                                patientid={patientId}
                                name={patientName}
                                phone={phoneNumber}
                                gender={gender}
                                age={ageInOrder}
                                orderId={orderId}
                                isForEditOrder={isForEditOrder}
                                onRefresh={isForEditOrder ? this.getAllTransactions : undefined}
                            />
                        ) : null)}
                </AnimatePresence>

                {activeOrder && (
                    <CancelOrderOrBooking
                        activeTab={
                            activeTab === ACTIVE_TAB.ALL_ORDERS && activeOrder.type
                                ? (activeOrder.type as ActiveTab)
                                : activeTab
                        }
                        orderDetails={activeOrder}
                        onClose={() => this.toggleActiveOrder(undefined)}
                        onRefresh={this.getAllTransactions}
                    />
                )}

                {amIDoctorOnly() && (
                    <GetPayoutsModal
                        isVisible={Boolean(isPayoutsModalVisible)}
                        payouts={payouts || []}
                        closeMe={this.togglePayoutsModal}
                    />
                )}

                {amIDoctorOnly() && (
                    <BankAccounts
                        isVisible={Boolean(isBankAccountsModalVisible)}
                        closeMe={this.toggleBankAccountsModal}
                        isForModal
                    />
                )}

                {Boolean(editOrder) && (
                    <SelectSlotModal
                        closeMe={() => this.toggleEditOrder()}
                        vendor={vendor}
                        vendor_id={vendor_id}
                        addressFormInput={addressFormInput}
                        selectedSlotDetails={selectedSlotDetails}
                        order={editOrder}
                        onRefresh={this.getAllTransactions}
                        patientName={editOrder?.patient_name || ''}
                    />
                )}
            </div>
        );
    }
}

export default connect()(withRouter(HEDashboard));
